import { render, staticRenderFns } from "./SupplierTableAudit.vue?vue&type=template&id=012b72a9&scoped=true&"
import script from "./SupplierTableAudit.vue?vue&type=script&lang=js&"
export * from "./SupplierTableAudit.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTableAudit.vue?vue&type=style&index=0&id=012b72a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b72a9",
  null
  
)

export default component.exports